import { render } from "./PlaceListSlider.vue?vue&type=template&id=5ccc27fa"
import script from "./PlaceListSlider.vue?vue&type=script&lang=js"
export * from "./PlaceListSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__